import { IconColor } from "../Icon";
import { TextColor } from "../Text";
import { IconTextColor } from "./enums";

/**
 * Konverze {@link IconTextColor} na {@link IconColor}. V případě nezdaru vrací jako výchozí barvu {@link IconColor.blackWhite}.
 * @param iconTextColor
 */
export const getIconColor = (iconTextColor: IconTextColor): IconColor => {
    return Object.values(IconColor).find(iconColor => iconColor.toString() === iconTextColor.toString()) ?? IconColor.blackWhite;
};

/**
 * Konverze {@link IconTextColor} na {@link TextColor}. V případě nezdaru vrací jako výchozí barvu {@link TextColor.blackWhite}.
 * @param iconTextColor
 */
export const getTextColor = (iconTextColor: IconTextColor): TextColor => {
    return Object.values(TextColor).find(textColor => textColor.toString() === iconTextColor.toString()) ?? TextColor.blackWhite;
};
